

function StartSelect(){
    $('.amortization-basic-single').select2();
}
function FancyBox(){
    $(".line-button").click(function() {
        $.fancybox.open({
            src: "#popup-temp",
            type: "inline"
        });
    });
}
function CalculateIndividualTerms(amount, amortiz, procent, prePayment){
    if(prePayment)amount = amount - ((amount/100)*prePayment);
    const effectiveRate = Math.pow(1 + procent / 2, 2) - 1;
    const monthlyPeriodicRate = Math.pow(1 + effectiveRate, 1 / 12) - 1;
    const monthlyPayment =
        (monthlyPeriodicRate * amount) /
        (1 - Math.pow(1 + monthlyPeriodicRate, - (amortiz * 12)));
    return monthlyPayment.toFixed(2);
}
function IndividualTerms(){
    let listlenders = $('.calculate-payment').closest('.terms_wrapper').find('.table-ante-row');
    let amount = parseFloat($('.calculate-payment').closest('.calculator').find('input[name=amount]').val());
    let amortization, prePayment;
    if($('.city-area-term').length > 0 || $('.lenders').length > 0 || $('.calculator-term').length > 0 || $('.individual-term').length > 0)amortization = parseFloat($('.calculate-payment').closest('.terms').find('select[name=amortization]').val());

    console.log('amortization',amortization)
    console.log('amount',amount)
    listlenders.each(function (){
        let perlay = $(this).find('.parlay');

        perlay.each(function (){

            if($(this).find('h4').text().length >6){
                let procent1 = parseFloat($(this).find('h4').text().substring(0, $(this).find('h4').text().indexOf('-')))/100;
                let monthly1 = CalculateIndividualTerms(amount,amortization,procent1,prePayment);
                let procent2 = parseFloat($(this).find('h4').text().substring($(this).find('h4').text().indexOf('-') + 1))/100;
                let monthly2 = CalculateIndividualTerms(amount,amortization,procent2,prePayment);
                $(this).find('span').text(`$${monthly1}/mo - $${monthly2}/mo `)
            }
            else {
                let procent = parseFloat($(this).find('h4').text())/100;
                let monthly = CalculateIndividualTerms(amount,amortization,procent,prePayment);
                $(this).find('span').text(`$${monthly}/mo`)
            }
        })
    })
}
function ClickCalculate(){
    $(document).on('click','.calculate-payment',function (){
        IndividualTerms();
    })
}
$(document).ready(function(){
    StartSelect();
    FancyBox();
    if($('.individual-term').length > 0 || $('.lenders').length > 0 || $('.city-area-term').length > 0 || $('.calculator-term').length > 0){
        ClickCalculate();
        IndividualTerms();
    }
});

$(window).load(function(){

});

$(window).resize(function(){

});